import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  for: "requisiteField",
  class: "form-label"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  for: "feedbackText",
  class: "form-label"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    "dialog-class": "modal-md",
    title: _ctx.helper.trans('fraudex.leave_feedback'),
    "body-class": "pt-3"
  }, {
    default: _withCtx(() => [
      (_ctx.requisite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "requisiteField",
                value: _ctx.requisite,
                readonly: ""
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.helper.trans('fraudex.comment')), 1),
              _createVNode(_component_FormInputWrapper, {
                field: "text",
                form: "fraudexFeedback"
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("textarea", {
                    class: _normalizeClass(["form-control", parentProps.class]),
                    id: "feedbackText",
                    rows: "4",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.feedbackText) = $event)),
                    placeholder: _ctx.helper.trans('fraudex.comment_placeholder')
                  }, null, 10, _hoisted_7), [
                    [_vModelText, _ctx.feedbackText]
                  ])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', false))),
        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loaderSubmit",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
            disabled: !_ctx.feedbackText || _ctx.feedbackText.trim().length === 0,
            class: "btn btn-outline-primary btn-sm text-capitalize-first"
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-paper-plane me-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.send')), 1)
          ], 8, _hoisted_8)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}